module.exports = __webpack_public_path__ + "img/secure.c7617eb6.png";